import { React } from 'react';

export default function Transition() {
  return (
    <div className="w-full flex justify-center">
      <img src="https://i.imgur.com/Fr0EczZ.gif" className="rounded-full" />
    </div>
  );
}
